import { zodResolver } from '@hookform/resolvers/zod';
import Button from 'components/form/Button';
import { NumberInput } from 'components/form/NumberInput';
import SelectInput from 'components/form/SelectInput';
import { useForm, useWatch } from 'react-hook-form';
import { coins } from 'utils/coins';
import { z } from 'zod';
import ModalComp from 'components/layouts/Modal';
import { formatNumber } from 'helpers';

interface ExchangeTabProps {
  toggleModal: () => void;
}

const ExchangeSchema = z
  .object({
    from: z.string(),
    to: z.string(),
    amount: z.string().min(4, 'amount is too small'),
  })
  .refine(
    (data) => {
      if (data.from !== data.to) {
        return false;
      }
      if (formatNumber(data.amount) >= 100) {
        return false;
      }

      return false;
    },
    (data) => {
      const message =
        data.from === data.to
          ? "you can't convert to the same crypto currency"
          : 'amount must be greater than 100';
      const path = data.from === data.to ? 'to' : 'amount';
      return {
        message,
        path: [path],
      };
    }
  );

type ExchangeSchemaType = z.infer<typeof ExchangeSchema>;

const ExchangeTab = ({ toggleModal }: ExchangeTabProps) => {
  const {
    control,
    handleSubmit,
    trigger,
    formState: { isDirty, isValid },
  } = useForm<ExchangeSchemaType>({
    resolver: zodResolver(ExchangeSchema),
    mode: 'onTouched',
  });
  const onSubmit = (data: any) => {
    console.log(data);
  };

  return (
    <ModalComp toggleModal={toggleModal} width="md:w-[540px]">
      <div className="p-5">
        <form
          className="flex flex-col gap-y-8"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="flex flex-col gap-y-2">
            <label htmlFor="coin" className="font-semibold">
              From:
            </label>

            <SelectInput
              control={control}
              options={coins}
              name="from"
              containerClass="bg-white !py-3 md:!py-1"
              handleOnChange={() => trigger('to')}
            />
          </div>
          <div className="flex flex-col gap-y-2">
            <label htmlFor="coin" className="font-semibold">
              To:
            </label>

            <SelectInput
              control={control}
              options={coins}
              name="to"
              containerClass="bg-white !py-3 md:!py-1"
              handleOnChange={() => trigger('to')}
            />
          </div>
          <div className="flex flex-col gap-y-2">
            <label htmlFor="coin" className="font-semibold">
              Amount:
            </label>

            <NumberInput
              control={control}
              name="amount"
              placeholder="$12,000"
              prefix={'$'}
              decimalScale={0}
              fixedDecimalScale
              className="py-3 md:py-1"
              required
            />
          </div>
          <div className="mt-2 flex items-center justify-between">
            <p className="text-lg font-semibold text-gray-500">Total:</p>
            <p>{useWatch({ control, name: 'amount' }) ?? '$0'}</p>
          </div>
          <Button
            className="flex w-full items-center justify-center gap-x-3 rounded-md bg-green-500 !py-2 text-white"
            disabled={!isValid || !isDirty}
          >
            proceed
          </Button>
        </form>
      </div>
    </ModalComp>
  );
};

export default ExchangeTab;
